import { render } from "./FirstRun.vue?vue&type=template&id=50d59958&scoped=true&ts=true"
import script from "./FirstRun.vue?vue&type=script&lang=ts"
export * from "./FirstRun.vue?vue&type=script&lang=ts"

import "./FirstRun.vue?vue&type=style&index=0&id=50d59958&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d59958"]])

export default __exports__